import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "group p-4 my-4 bg-blue-50 rounded-lg shadow-md ring-1 ring-blue-200 transition-all duration-200" }
const _hoisted_2 = { class: "flex flex-col gap-3" }
const _hoisted_3 = { class: "flex flex-col gap-2 text-blue-800" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = { class: "font-medium" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = { class: "font-medium" }

import { computed } from 'vue';
import type { OperationInfo } from '@/types/v2/task/animal-transfer/operation.types';

interface Props {
    transferInfo?: OperationInfo;
    transferBalance: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StatusCard',
  props: {
    transferInfo: { default: undefined },
    transferBalance: { default: 0 }
  },
  setup(__props: any) {

const props = __props;

const remainingToTransfer = computed(() => {
    if (!props.transferInfo?.amount) return 0;
    return props.transferInfo.amount - props.transferBalance;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-lg font-semibold text-blue-900" }, " Transfer Status: ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _cache[0] || (_cache[0] = _createTextVNode(" Total transferred: ")),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.transferBalance) + " fish", 1)
        ]),
        _createElementVNode("p", _hoisted_6, [
          _cache[1] || (_cache[1] = _createTextVNode(" Left to be transferred: ")),
          _createElementVNode("span", _hoisted_7, _toDisplayString(remainingToTransfer.value) + " fish", 1)
        ])
      ])
    ])
  ]))
}
}

})